import { mapFieldErrorsToSections } from '@vlabs/monokit/shared/lib/errors';
import type { FieldValidationError, SectionRule } from '@vlabs/monokit/shared/lib/errors';

import type { SourceStreamSection } from './types';

const ANALYTICS_PATH_PATTERN = /^analytics\.(\d+)(\.|$)/;

// Всё, кроме analytics[i].*, относится к «Основным параметрам»
// (name, description, group_id, data.*, autorestart.*, location.*).
const RULES: SectionRule<SourceStreamSection>[] = [
  { pattern: ANALYTICS_PATH_PATTERN, section: (match) => `va:${Number(match[1])}` },
  { pattern: /.*/, section: 'main' },
];

export function mapErrorsToSections(
  errors: FieldValidationError[],
): Partial<Record<SourceStreamSection, boolean>> {
  return mapFieldErrorsToSections(errors, RULES);
}
